import type { CountryCode } from 'libphonenumber-js/max';
import { parsePhoneNumberWithError } from 'libphonenumber-js/max';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { formatNationalByCountryCode, getExamplePhone } from '@/lib/phone';
import { formMessages } from '@/messages/forms';

export const usePhoneInput = () => {
  const { formatMessage } = useIntl();
  const { clearErrors, setError, setValue, watch } = useFormContext();
  const [phonePrefix, phone] = watch(['phonePrefix', 'phone']);
  const [examplePhone, setExamplePhone] = useState<string>('');
  useEffect(() => {
    if (phone && phonePrefix.code) {
      try {
        const phoneNumber = parsePhoneNumberWithError(phone, {
          defaultCountry: phonePrefix.code,
          extract: false,
        });
        setValue(
          'phone',
          formatNationalByCountryCode(
            phonePrefix.code,
            phoneNumber.formatNational(),
          ),
        );
        if (phoneNumber.isValid()) {
          clearErrors('phone');
        } else {
          setError('phone', {
            message: formatMessage(formMessages.invalidPhone),
          });
        }
      } catch (error) {
        setError('phone', {
          message: formatMessage(formMessages.invalidPhone),
        });
      }
    }
  }, [phone, phonePrefix]);

  useEffect(() => {
    const phoneNumber = getExamplePhone(phonePrefix.code as CountryCode);
    if (phoneNumber) setExamplePhone(phoneNumber);
  }, [phonePrefix]);

  return { examplePhone };
};
